import { Component, OnInit } from '@angular/core';
import { AdministracionUsuariosService } from '../services/administracion-usuarios.service';
import { FiltroAdminDTO } from '../models/filtroAdminDTO';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ListasService } from '../../../services/listas.service';
import { FormFieldOption } from '../../../dto/util/form-field';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ultimos-usuarios',
  templateUrl: './ultimos-usuarios.component.html',
  styleUrl: './ultimos-usuarios.component.scss',
})
export class UltimosUsuariosComponent implements OnInit {
  entidades: FormFieldOption[] = [];
  columnasUltimosUsuarios: TableColumn[] = [];
  usuariosFormateados: any[] = [];
  usuarios: any[] = [];
  tamanoPagina = 10;
  totalPaginas = 0;
  paginaActual = 1;
  paginas: number[] = [];
  filtroAdminLider: FiltroAdminDTO = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: true,
    ordenarPor: 'nombre',
    filtros: {
      nombres: '',
      apellidos: '',
      idTipoIdentificacion: '',
      identificacion: '',
      correoElectronico: '',
      entidad: '',
      estado: null,
      fechaActivacion: '',
      ultimosUsuariosSemana: true,
    },
  };

  // Multilenguaje
  tableText: any = {};
  constructor(
    private adminUsuariosService: AdministracionUsuariosService,
    private listaService: ListasService,
    private translate: TranslateService
  ) {
    // Multilenguaje
    this.translate.stream('ultimos-usuarios').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this.initColumnsUltimosUsuarios();
    });
  }

  ngOnInit() {
    this.cargarUsuarios();
    this.initColumnsUltimosUsuarios();
    // Lista de entidades
    this.listaService.getEntidades().subscribe(entidades => {
      this.entidades = entidades.map(entidad => ({
        Id: entidad.Id ?? '',
        Nombre: entidad.Entidad || '',
      }));
      this.initColumnsUltimosUsuarios();
    });
  }

  cargarUsuarios() {
    this.adminUsuariosService
      .obtenerUsuariosUltimaSemana(this.filtroAdminLider)
      .subscribe({
        next: response => {
          this.usuarios = response.data.registros;
          this.totalPaginas = response.data.totalPaginas;
          this.paginaActual = response.data.numeroPagina;
          this.tamanoPagina = response.data.cantidadRegistros;

          this.usuariosFormateados = this.usuarios.map(usuario => ({
            id: usuario.Persona.Usuario.Id,
            nombre:
              usuario.Primer_nombre +
              (usuario.Segundo_nombre ? ' ' + usuario.Segundo_nombre : '') +
              ' ' +
              usuario.Primer_apellido +
              (usuario.Segundo_apellido ? ' ' + usuario.Segundo_apellido : ''),
            correoElectronico: usuario.Persona.Correo_electronico,
            fechaActivacion: usuario.fechaActivacion
              ? new Date(usuario.fechaActivacion).toLocaleDateString()
              : null,
            entidad:
              usuario.Persona?.Usuario?.Tipos_Usuario[0]?.Tipo_Usuario?.Entidad
                ?.Entidad || '',
          }));
        },
        error: err => {
          console.error('Error al cargar los usuarios:', err);
        },
      });
  }

  initColumnsUltimosUsuarios() {
    this.columnasUltimosUsuarios = [
      {
        id: 'nombre',
        field: 'nombre',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: true,
        sortable: true,
        width: '12rem',
      },

      {
        id: 'correoElectronico',
        field: 'correoElectronico',
        title: this.tableText['correo'],
        type: 'text',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'fechaActivacion',
        field: 'fechaActivacion',
        title: this.tableText['fecha-activacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'entidad',
        field: 'entidad',
        title: this.tableText['entidad'],
        type: 'select',
        elements: this.entidades,
        value: 'Id',
        option: 'Nombre',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
    ];
  }

  buscarUltimosUsuarios(event: FiltroDto<object>) {
    this.filtroAdminLider.ordenarPor =
      event.ordenarPor == '' ? 'nombres' : event.ordenarPor;
    this.filtroAdminLider.filtros = event.filtros;
    this.filtroAdminLider.ordenarAsc = event.ordenarAsc;
    this.filtroAdminLider.pagina = +(event.selectedPage ?? 1);
    this.filtroAdminLider.tamanoPagina = +event.tamanoPagina;
    this.usuarios = [];
    this.cargarUsuarios();
  }
}
